import PropTypes from 'prop-types'

import View from '../../../components/bantrab/view'
import SimpleView from '../../../components/bantrab/view/simple'
import Detail from '../../../components/bantrab/courses/detail'
import LaChiripaDetail from '../../../components/bantrab/courses/detail/lachiripa'
import { getBaseViewInfo } from '../../../components/bantrab/view/functions'

import { getPage } from '../../../api/bantrab'

import { COURSES_DETAIL_QUERY as PAGE_QUERY } from '../../../api/bantrab/queries'

async function getServerSideProps (context) {
  const { id } = context.params

  const { head, navbar, footer, raw } = await getBaseViewInfo()

  let page = await getPage(id, PAGE_QUERY)
  page = await page.json()

  const body = page

  return {
    props: {
      head,
      navbar,
      body,
      footer,
      integrationSettings: raw.siteInfo.crehanaintegrationsettings
    }
  }
}

const Home = ({ head, navbar, body, footer, integrationSettings }) => {
  return body.provider === 'lachiripa'
    ? <SimpleView
      {...{ head, navbar, footer }}>
      <LaChiripaDetail
        course={body}
        integrationSettings={integrationSettings} />
    </SimpleView>
    : <View
      {...{ head, navbar, footer }}>
      <Detail
        course={body}
        integrationSettings={integrationSettings} />
    </View>
}

Home.propTypes = {
  head: PropTypes.object,
  navbar: PropTypes.object,
  body: PropTypes.object,
  footer: PropTypes.object,
  integrationSettings: PropTypes.object
}

export { getServerSideProps }
export default Home
